
import React from "react";
import { Nav, Badge, Image } from '@themesberg/react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link, useLocation } from 'react-router-dom';
import "./sidebar.css";

const SidebarItem = (props) => {
  const { title, link, external, target, icon, image, badgeText, badgeBg = "secondary", badgeColor = "primary", setShow } = props;
  const location = useLocation();
  const { pathname } = location;
  
  const classNames = badgeText ? "d-flex justify-content-between align-items-center" : "d-flex align-items-center";
  const navItemClassName = link === pathname ? "active custom-sidebar-nav-item" : "custom-sidebar-nav-item";
  const linkProps = external ? { href: link } : { as: Link, to: link };

  const handleOnClick = () => {
    if (setShow) {
        setShow(false);
    }
  }

  return (
    <Nav.Item className={navItemClassName} onClick={handleOnClick}>
      <Nav.Link {...linkProps} target={target} className={classNames}>
        <div className="d-flex align-items-center">
          {icon ? <span className="sidebar-icon"><FontAwesomeIcon icon={icon} /> </span> : null}
          {image ? <span className="sidebar-icon"><Image src={image} width={20} height={20} className="svg-icon" /> </span> : null}

          <span className="sidebar-text">{title}</span>
        </div>
        {badgeText ? (
          <Badge pill bg={badgeBg} text={badgeColor} className="badge-md notification-count ms-2">{badgeText}</Badge>
        ) : null}
      </Nav.Link>
    </Nav.Item>
  );
};

export default SidebarItem;
